import { type FC } from 'react'
import styled from '@emotion/styled'
import { useTheme } from '@emotion/react'

import { TeradataMonoLogo } from '@segment/matcha/components/CompanyLogos/CompanyMono'

import Section from '@segment/matcha/recipes/Section'
import TestimonialBase, * as Testimonial from '@segment/matcha/recipes/Testimonial'

import TeradataTestimonialBackgroundSvg from './assets/TeradataTestimonialBackground.svg'
import avatar from './assets/Avatar.jpeg'

const testimonialData = {
  text: `“I often talk about data – it's not like oil. To me, it's more like water. You have a lot of water that's not usable. You have a lot of things in data today that aren't usable. Now, in order for AI to be really impactful in your organization, it has to start with data. Do you have clean data? Is that data pristine? Do you know the lineage of the data? Because, AI is nothing if it doesn't have clean data to essentially build intelligence off of, particularly when you talk about generative AI.”`,
  name: `Jacqueline Woods`,
  position: `CMO, Teradata`,
}
const TeradataTestimonial: FC = () => {
  const theme = useTheme()

  return (
    <Wrapper>
      <Section variant="centered">
        <StyledTestimonialBase>
          <Testimonial.Base height="auto" tokens={{ background: theme.palette.neutrals.white[100] }}>
            <Testimonial.BaseContentSlot>
              <Testimonial.BaseLogo>
                <TeradataMonoLogo color={theme.palette.twilio.gray[100]} />
              </Testimonial.BaseLogo>
              <Testimonial.BaseText tokens={{ color: theme.palette.twilio.gray[100] }}>
                {testimonialData.text}
              </Testimonial.BaseText>
            </Testimonial.BaseContentSlot>
            <Testimonial.BaseAuthorSlot>
              <Testimonial.AuthorAvatar
                width={60}
                height={60}
                alt={`Portrait of ${testimonialData.name}`}
                src={avatar}
              />
              <Testimonial.AuthorInfo>
                <Testimonial.AuthorName tokens={{ color: theme.palette.twilio.gray[100] }}>
                  {testimonialData.name}
                </Testimonial.AuthorName>
                <Testimonial.AuthorPosition tokens={{ color: theme.palette.twilio.gray[100] }}>
                  {testimonialData.position}
                </Testimonial.AuthorPosition>
              </Testimonial.AuthorInfo>
            </Testimonial.BaseAuthorSlot>
          </Testimonial.Base>
        </StyledTestimonialBase>
      </Section>
      <Background>
        <TeradataTestimonialBackgroundSvg width="100%" height="100%" />
      </Background>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  position: relative;
  background-color: ${({ theme }) => theme.palette.twilio.gray[100]};
  z-index: 0;
`

const Background = styled.div`
  background-color: ${({ theme }) => theme.palette.twilio.gray[100]};
  position: absolute;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: -1;

  ${({ theme }) => theme.breakpoints.up(`xxxl`)} {
    &::before,
    &::after {
      content: '';
      position: absolute;
      top: 0;
      width: 30%;
      height: 100%;
    }

    &::before {
      left: 0;
      background: linear-gradient(269.69deg, rgba(18, 28, 45, 0) 0.25%, #121c2d 60%);
    }

    &::after {
      right: 0;
      background: linear-gradient(-269.69deg, rgba(18, 28, 45, 0) 0.25%, #121c2d 60%);
    }
  }
`

const StyledTestimonialBase = styled(TestimonialBase)`
  max-width: 1040px;
`

export default TeradataTestimonial
